<template>
  <modal
    title="Restore Contact(s)"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <label class="label">Reason for Restoration:</label>
      <base-input placeholder="Enter" v-model="payload.suspendReason" />
    </div>

    <div class="actions flex justify-between cursor-pointer">
      <div @click="closeModal">
        <p>Cancel</p>
      </div>
      <div>
        <primary-button
          buttonText="Restore"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    contact: {
      required: true,
    },
    contactIds: {
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      payload: {
        contactId: this.contact.id,
        isSuspended: false,
        suspendReason: "",
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async restoreContact() {
      this.loading = true;
      try {
        const response = await this.$_blacklistContact(this.payload);
        console.log(response);
        this.generateToast("Contact(s) Restored!", "success");
        this.$emit("contact-restored");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    submit() {
      if (this.contactIds.length > 0) {
        this.contactIds.forEach((id) => {
          this.payload.contactId = id;
          this.restoreContact(id);
        });
      } else {
        this.restoreContact();
      }
    },
  },
};
</script>

<style scoped></style>
